<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <b-card>
          <b-form @submit.prevent="updateItem">
            <div class="mb-4">
              <a href="#" @click.prevent="goBack">
                <i class="fas fa-arrow-left"></i>
                Back to Assets List
                <!-- trở về danh sách tài sản -->
              </a>
              <div class="float-right">
                <button class="btn btn-primary" type="submit">Save</button>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-5">
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            id="select-group-assettypeid"
                            label="Asset Type (*):"
                            label-for="selectAssetTypeId"
                          >
                            <b-form-select
                              id="selectAssetTypeId"
                              v-model="form.assetTypeId"
                              :options="assetTypes"
                              value-field="id"
                              text-field="type"
                              required
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col>
                          <b-form-group
                            id="input-group-assetid"
                            label="Asset ID (*):"
                            label-for="inputAssetId"
                          >
                            <b-form-input
                              id="inputAssetId"
                              v-model="form.assetId"
                              placeholder="Input Asset ID"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="8">
                          <b-form-group
                            id="input-group-name"
                            label="Asset Name (*):"
                            label-for="inputName"
                          >
                            <b-form-input
                              id="inputName"
                              v-model="form.assetName"
                              required
                              placeholder="Inphut Asset Name"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <br /><br />
                <b-form-row>
                  <b-col cols="12" md="5" class="mb-4">
                    <b-container>
                      <b-row>
                        <b-col>
                          <b class="mr-2">
                            Asset Information
                            <!-- Thông tin tài sản -->
                          </b>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group
                            id="input-group-serial"
                            label="Serial Number:"
                            label-for="inputSerial"
                          >
                            <b-form-input
                              id="inputSerial"
                              v-model="form.serial"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group
                            id="select-group-employee"
                            label="Employee is using this asset:"
                            label-for="selectEmployee"
                          >
                            <!-- <b-form-input v-model="form.employeeId" disabled></b-form-input> -->
                            <multiselect
                              v-model="employee_selected"
                              placeholder
                              track-by="id"
                              label="mahovaten"
                              selectedLabel="Selecting"
                              select-label="Enter to select"
                              deselectLabel="Enter to delete"
                              :searchable="true"
                              :options="employees"
                              disabled
                            >
                            </multiselect>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group
                            id="select-group-departmentid"
                            label="Purchased by:"
                            label-for="selectDeparmentId"
                          >
                            <b-form-select
                              id="selectDepartmentId"
                              :options="departments"
                              value-field="id"
                              text-field="tendonvi"
                              v-model="form.departmentId"
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group
                            id="select-group-roonid"
                            label="Located at (*):"
                            label-for="selectRoomId"
                          >
                            <b-form-select
                              id="selectRoomId"
                              v-model="form.roomId"
                              :options="rooms"
                              value-field="id"
                              text-field="name"
                              required
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group
                            id="input-group-detail"
                            label="Description:"
                            label-for="inputDetail"
                          >
                            <b-form-input
                              id="inputDetail"
                              v-model="form.detail"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group
                            id="input-group-job"
                            label="Job:"
                            label-for="inputJob"
                          >
                            <b-form-input id="inputJob" v-model="form.job">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group
                            id="input-group-recievedDate"
                            label="Input Day:"
                            label-for="datepickerRecievedDate"
                          >
                            <vue-datepicker-local
                              v-model="form.wareHouseDate"
                              :local="local"
                              clearable
                              format="DD/MM/YYYY"
                              required
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="4">
                          <b-form-group
                            id="input-group-price"
                            label="Price:"
                            label-for="selectPrice"
                          >
                            <my-currency-input v-model="form.price" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <br /><br />
                <b-form-row>
                  <b-col cols="12" md="5" class="mb-4">
                    <b-container>
                      <b-row>
                        <b-col>
                          <b class="mr-2">
                            Asset Status
                            <!-- Tình trạng tài sản -->
                          </b>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group
                            id="select-group-assetstatus"
                            label="Asset Status (*):"
                            label-for="selectAssetStatus"
                          >
                            <b-form-select
                              id="selectAssetStatus"
                              v-model="form.assetStatus"
                              :options="assetStatusses"
                              required
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group
                            id="select-group-usagestatus"
                            label="Status (*):"
                            label-for="selectUsageStatus"
                          >
                            <b-form-select
                              id="selectUsageStatus"
                              v-model="form.status"
                              :options="tinhtrangtaisans"
                              value-field="id"
                              text-field="pickListValue"
                              required
                            >
                            </b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            id="input-group-purpose"
                            label="Purpose:"
                            label-for="inputPurpose"
                          >
                            <b-form-input
                              id="inputPurpose"
                              v-model="form.purpose"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-container>
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            id="input-group-notation"
                            label="Note:"
                            label-for="inputNotation"
                          >
                            <b-form-input
                              id="inputNotation"
                              v-model="form.notation"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-form-row>
              </div>
              <div class="col-7">
                <button
                  class="btn btn-info mb-2"
                  @click.prevent="openModelHistory"
                >
                  <i class="fas fa-plus"></i>
                  Update asset log
                  <!-- Cập nhật nhật ký tài sản -->
                </button>
                <b-table
                  id="historyTable"
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  bordered
                  sticky-header="450px"
                  :no-border-collapse="true"
                  table-variant="light"
                  :fields="historyFields"
                  :items="assetHistories"
                >
                  <template v-slot:cell(action)="data">
                    <div v-if="assetHistories[0].id == data.item.id">
                      <b-link
                        class="text-success mr-2"
                        href="#"
                        @click.prevent="automate_update(data)"
                      >
                        <i class="fas fa-cog"></i>
                      </b-link>
                      <b-link
                        class="text-primary mr-2"
                        href="#"
                        @click.prevent="openUpdateModelHistory(data)"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </b-link>
                      <b-link
                        class="text-danger"
                        href="#"
                        @click.prevent="deleteHistory(data)"
                      >
                        <i class="fas fa-trash"></i>
                      </b-link>
                    </div>
                    <div v-else>
                      <b-link
                        class="text-danger"
                        href="#"
                        @click.prevent="deleteHistory(data)"
                      >
                        <i class="fas fa-trash"></i>
                      </b-link>
                    </div>
                  </template>
                  <template v-slot:cell(recievedDate)="data">
                    <span>
                      {{ data.item.recievedDate | moment("DD/MM/YYYY") }}
                    </span>
                  </template>
                  <template v-slot:cell(returnedDate)="data">
                    <span>
                      {{ data.item.returnedDate | moment("DD/MM/YYYY") }}
                    </span>
                  </template>
                </b-table>
              </div>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      @ok="addHistory"
      @update="updateHistory"
      @cancel="clearModel"
      @hidden="clearModel"
      header-bg-variant="info"
      header-text-variant="light"
      style="white-space: pre-wrap;"
      size="lg"
    >
      <template v-slot:modal-title>
        <div>
          Asset ID is {{ form.assetId }}
          <!-- Tài sản có mã {{form.assetId}} -->
        </div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button v-if="!updating" variant="success" @click="ok()">
          Add
          <!-- Thêm -->
        </b-button>
        <b-button v-else variant="success" @click="updateHistory">
          Update
          <!-- Cập nhật -->
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Close
          <!-- Đóng -->
        </b-button>
      </template>
      <b-container>
        <b-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">
              Received date
              <!-- Ngày nhận -->
            </label>
            <code>*</code>
          </b-col>
          <b-col cols="8" class="my-datepicker">
            <vue-datepicker-local
              v-model="historyForm.recievedDate"
              :local="local"
              clearable
              format="DD/MM/YYYY"
              required
            />
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">
              Return date
              <!-- Ngày trả -->
            </label>
          </b-col>
          <b-col cols="8" class="my-datepicker">
            <vue-datepicker-local
              v-model="historyForm.returnedDate"
              :local="local"
              clearable
              format="DD/MM/YYYY"
            />
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">Employee is using</label>
            <code>*</code>
          </b-col>
          <b-col cols="8">
            <multiselect
              v-model="history_employee_selected"
              placeholder
              track-by="id"
              label="mahovaten"
              selectedLabel="Selecting"
              select-label="Enter to selected"
              deselectLabel="Enter to delete"
              :searchable="true"
              :options="employees"
            >
            </multiselect>
            <!-- <b-form-select v-model="historyForm.employeeId" :options="employees" value-field="id" text-field="hovaten" required></b-form-select> -->
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="3">
            <label class="mr-2">
              Note
              <!-- Ghi chú -->
            </label>
          </b-col>
          <b-col cols="8">
            <b-form-input v-model="historyForm.notation"></b-form-input>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import MyCurrencyInput from "../components/App/MyCurrencyInput";

export default {
  name: "AssetUpdate",

  components: {
    VueDatepickerLocal,
    Multiselect,
    MyCurrencyInput,
  },

  data() {
    return {
      params_search: "",
      empCode: "",
      router_his: "",
      form: {
        id: 0,
        assetId: "",
        assetName: "",
        assetTypeId: [],
        employeeId: 0,
        employeeFullName: "",
        departmentId: [],
        recievedDate: null,
        assetStatus: [],
        usageStatus: [],
        price: 0,
        notation: "",
        serial: "",
        detail: "",
        job: "",
        purpose: "",
        roomId: 0,
        status: 0,
        wareHouseDate: null,
      },
      historyFields: [
        {
          key: "recievedDate",
          // label: "Ngày giao"
          label: "Delivery date",
        },
        {
          key: "returnedDate",
          label: "Return date",
          // label: "Ngày trả"
        },
        {
          key: "employeeFullName",
          label: "Name",
          // label: "Tên nhân viên"
        },
        {
          key: "notation",
          // label: "Ghi chú"
          label: "Note",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "75px !important" },
        },
      ],
      historyForm: {
        id: 0,
        assetId: null,
        recievedDate: null,
        returnedDate: null,
        employeeId: null,
        employeeFullName: null,
        notation: null,
      },
      rooms: [],
      roomEnabled: true,
      historyIndex: null,
      updating: false,
      modalShow: false,
      assetHistories: [],
      employees: [],
      departments: [],
      assetTypes: [],
      tinhtrangtaisans: [],
      assetStatusses: ["Tốt", "Hỏng"],
      usageStatusses: ["Đang sử dụng", "Không sử dụng", "Đang sửa chữa"],
      employee_selected: [],
      history_employee_selected: null,
      optionsEmployees: [],

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ),
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ),
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"),
      },
    };
  },

  computed: {
    // Employees() {
    //     var emp_list = this.employees.slice();
    //     for (var emp of emp_list) {
    //         emp.hovaten = emp.manhanvien + " - " + emp.hovaten;
    //     }
    //     emp_list.unshift({id: null, hovaten: ""});
    //     return emp_list;
    // },
  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/asset/${to.params.slug}`),
        axios.get("/api/employee/getall"),
        axios.get("/api/assettype"),
        axios.get("/api/department"),
        axios.get(`/api/AssetHistory/${to.params.slug}`),
        axios.get("/api/picklist/tinhtrangtaisan"),
        axios.get("/api/room"),
      ])
      .then(
        axios.spread(
          (
            asset,
            employee,
            assettype,
            department,
            assetHistory,
            tinhtrangtaisan,
            rooms
          ) => {
            next((vm) =>
              vm.initData(
                asset.data,
                employee.data,
                assettype.data.items,
                department.data,
                assetHistory.data.items,
                tinhtrangtaisan.data,
                rooms.data,
                to.params,
                from.params,
                from.matched[0]
              )
            );
          }
        )
      );
  },

  methods: {
    initData(
      asset,
      employees,
      assetTypes,
      departments,
      assetHistories,
      tinhtrangtaisans,
      rooms,
      toParams /*Search query from Asset Menu*/,
      fromParams,
      fromMatched
    ) {
      this.params_search = toParams.search;
      this.empCode = fromParams.slug; /*Employee ID from Edit HR Record Menu*/
      if (fromMatched) this.router_his = fromMatched["path"];
      else this.router_his = "/asset";
      this.form.id = asset.id;
      this.form.assetId = asset.assetId;
      this.form.assetName = asset.name;
      this.form.assetTypeId = asset.assetTypeId;
      this.form.employeeId = asset.employeeId;
      this.employee_selected = employees.find((x) => x.id == asset.employeeId);
      if (typeof this.employee_selected != "undefined") {
        this.form.employeeId = this.employee_selected.id;
        this.form.employeeFullName = this.employee_selected.hovaten;
      }
      this.form.departmentId = asset.departmentId;
      this.form.recievedDate = asset.recievedDate;
      this.form.returnedDate = asset.returnedDate;
      this.form.assetStatus = asset.assetStatus;
      this.form.usageStatus = asset.usageStatus;
      this.form.price = parseInt(asset.price); // Price is not currently a string for some reason. Will change back at latter date
      this.form.notation = asset.notation;
      this.form.serial = asset.serial;
      this.form.detail = asset.detail;
      this.form.job = asset.job;
      this.form.purpose = asset.purpose;
      this.form.roomId = asset.roomId;
      this.form.status = asset.status;
      this.form.wareHouseDate = asset.wareHouseDate;

      this.rooms = rooms;
      this.assetTypes = assetTypes;
      this.employees = employees;
      this.departments = departments;
      this.assetHistories = assetHistories;
      this.tinhtrangtaisans = tinhtrangtaisans;
    },

    updateItem() {
      if (this.employee_selected != null) {
        this.form.employeeId = this.employee_selected.id;
        this.form.employeeFullName = this.employee_selected.hovaten;
      }
      axios
        .put("/api/Asset", {
          id: this.form.id,
          assetId: this.form.assetId,
          name: this.form.assetName,
          assetTypeId: this.form.assetTypeId,
          employeeId: this.form.employeeId,
          // employeeFullName: this.form.employeeFullName,
          departmentId: this.form.departmentId,
          recievedDate: this.form.recievedDate,
          returnedDate: this.form.returnedDate,
          assetStatus: this.form.assetStatus,
          usageStatus: this.form.usageStatus,
          price: "" + this.form.price,
          notation: this.form.notation,
          Serial: this.form.serial,
          Detail: this.form.detail,
          Job: this.form.job,
          Purpose: this.form.purpose,
          RoomId: this.form.roomId,
          Status: this.form.status,
          wareHouseDate: this.form.wareHouseDate,
        })
        .then((res) => {
          this.$toast.success("Update successfully", "Success", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    addHistory(obj) {
      if (
        this.assetHistories.length > 0 &&
        new Date(this.historyForm.recievedDate) <
          new Date(this.assetHistories[0].returnedDate)
      ) {
        this.$toast.error(
          "Ngày nhận nhỏ hơn ngày trả lần trước xxx. Xin vui lòng nhập lại",
          "Error",
          { timeout: 3000 }
        );
        obj.preventDefault();
      } else if (
        this.historyForm.returnedDate != null &&
        new Date(this.historyForm.recievedDate) >
          new Date(this.historyForm.returnedDate)
      ) {
        this.$toast.error(
          "Ngày nhận nhỏ hơn ngày trả. Xin vui lòng nhập lại",
          "Error",
          { timeout: 3000 }
        );
        obj.preventDefault();
      } else if (
        !this.historyForm.recievedDate ||
        !this.history_employee_selected
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Error", {
          timeout: 2000,
        });
        obj.preventDefault();
      } else {
        this.historyForm.employeeId = this.history_employee_selected.id;
        this.historyForm.assetId = this.form.assetId;
        axios
          .post("/api/AssetHistory", this.historyForm)
          .then((res) => {
            var employee = this.employees.find(
              (x) => x.id == res.data.employeeId
            );

            if (this.historyForm.returnedDate == null)
              this.employee_selected = employee;
            else this.employee_selected = [];
            res.data.employeeFullName = employee.hovaten;
            this.assetHistories.unshift(res.data);
            this.$toast.success("Add log successfully", "Success", {
              timeout: 2000,
            });

            this.clearModel();
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
          });
      }
    },

    updateHistory(obj) {
      if (this.historyForm.returnedDate == "")
        this.historyForm.returnedDate = null;

      if (
        this.assetHistories.length > 1 &&
        new Date(this.historyForm.recievedDate) <
          new Date(this.assetHistories[1].returnedDate)
      ) {
        this.$toast.error(
          "Ngày nhận nhỏ hơn ngày trả lần trước. Xin vui lòng nhập lại",
          "Error",
          { timeout: 3000 }
        );
        obj.preventDefault();
      } else if (
        this.historyForm.returnedDate != null &&
        this.historyForm.recievedDate > this.historyForm.returnedDate
      ) {
        this.$toast.error(
          "Ngày nhận nhỏ hơn ngày trả. Xin vui lòng nhập lại",
          "Error",
          { timeout: 3000 }
        );
        obj.preventDefault();
      } else if (this.historyForm.recievedDate == "") {
        this.$toast.error("Vui lòng nhập thông tin received Date", "Error", {
          timeout: 2000,
        });
        obj.preventDefault();
      } else if (!this.history_employee_selected) {
        this.$toast.error("Vui lòng nhập thông tin employee", "Error", {
          timeout: 2000,
        });
        obj.preventDefault();
      } else {
        if (
          this.historyForm.returnedDate == null ||
          this.historyForm.returnedDate == ""
        )
          this.employee_selected = this.history_employee_selected;
        else this.employee_selected = null;

        // var employeeFullName = this.history_employee_selected.hovaten;
        this.historyForm.employeeId = this.history_employee_selected.id;
        this.historyForm.employeeFullName = this.history_employee_selected.hovaten;
        axios
          .put("/api/AssetHistory", this.historyForm)
          .then((res) => {
            // this.historyForm.employeeFullName = employeeFullName;

            this.assetHistories[this.historyIndex] = JSON.parse(
              JSON.stringify(this.historyForm)
            );
            const temp = JSON.parse(JSON.stringify(this.assetHistories));
            this.assetHistories = JSON.parse(JSON.stringify(temp));

            this.clearModel();
            this.historyIndex = null;
            // this.historyForm.employeeId = this.history_employee_selected.id;
            this.$toast.success("Update log successfully", "Success", {
              timeout: 2000,
            });
          })
          .catch((err) => {
            this.$toast.error(err.ToString(), "Error", { timeout: 3000 });
          });
      }
    },

    deleteHistory(data) {
      this.$toast.question("Do you really want to delete it?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/AssetHistory/${data.item.id}`)
                .then((res) => {
                  this.assetHistories.splice(data.index, 1);
                  this.employee_selected = null;
                  this.$toast.success("Delete successfully", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    openModelHistory() {
      if (this.assetHistories.length == 0) this.modalShow = true;
      else if (
        this.assetHistories[0].returnedDate == null ||
        this.assetHistories[0].returnedDate == ""
      ) {
        this.$toast.error(
          "Tài sản chưa trả. Vui lòng cập nhật ngày trả của người giữ tài sản trước!",
          "TEST",
          { timeout: 3000 }
        );
      } else this.modalShow = true;
    },

    openUpdateModelHistory(data) {
      this.historyForm.id = data.item.id;
      this.historyForm.assetId = data.item.assetId;
      this.historyForm.recievedDate = data.item.recievedDate;
      this.historyForm.returnedDate = data.item.returnedDate;
      this.history_employee_selected = this.employees.find(
        (x) => x.id == data.item.employeeId
      );
      this.historyForm.notation = data.item.notation;
      this.historyIndex = data.index;
      this.modalShow = true;
      this.updating = true;
    },

    clearModel() {
      this.historyForm.id = 0;
      this.historyForm.assetId = null;
      this.historyForm.recievedDate = null;
      this.historyForm.returnedDate = null;
      this.historyForm.employeeId = null;
      this.history_employee_selected = null;
      this.historyForm.notation = null;
      this.updating = false;
      this.modalShow = false;
    },

    goBack() {
      if (["/asset", "/edit_asset/:slug"].includes(this.router_his))
        this.$router.push({
          name: "asset",
          params: { q: this.params_search },
        });
      else if (["/hr_record/:slug"].includes(this.router_his))
        this.$router.push({
          name: "edit_hr_record",
          params: { slug: this.empCode },
        });
      // else this.$router.go(-1);
    },

    unlockRoom() {
      axios.get(`/api/Room/${this.form.departmentId}`).then((res) => {
        this.rooms = res.data;
        this.roomEnabled = true;
      });
    },

    automate_update(data) {
      if (data.item.returnedDate != null) {
        this.$toast.error("Tài sản này đã trả!", "Error", { timeout: 2000 });
        data.preventDefault();
      }
      this.historyForm.id = data.item.id;
      this.historyForm.assetId = data.item.assetId;
      this.historyForm.recievedDate = data.item.recievedDate;
      this.historyForm.returnedDate = new Date();
      this.history_employee_selected = this.employees.find(
        (x) => x.id == data.item.employeeId
      );

      this.historyForm.notation = data.item.notation;
      this.historyIndex = data.index;
      this.historyForm.employeeId = this.history_employee_selected.id;
      axios
        .put("/api/AssetHistory/automate", this.historyForm)
        .then((res) => {
          this.historyForm.employeeFullName = this.history_employee_selected.hovaten;
          this.employee_selected = null;

          this.assetHistories[this.historyIndex] = JSON.parse(
            JSON.stringify(this.historyForm)
          );
          const temp = JSON.parse(JSON.stringify(this.assetHistories));
          this.assetHistories = JSON.parse(JSON.stringify(temp));

          this.clearModel();
          this.historyIndex = null;
          // this.historyForm.employeeId = this.history_employee_selected.id;
          this.form.status = this.tinhtrangtaisans.find(
            (x) => x.pickListValue == "Lưu kho"
          ).id;
          this.$toast.success("Update log successfully", "Success", {
            timeout: 2000,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
  },
};
</script>
